export default (that, isCheckBox) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    type: 'seq'
  },
  {
    title: that. $l('INDEX.btn_choice') || '选择',
    width: 70,
    align: 'center',
    type: isCheckBox ? 'checkbox' : 'radio'
  },
  {
    title: that. $l('INDEX.goods_label_orderGoodsNo') || '产品编号',
    field: 'orderGoodsNo',
    minWidth: 150,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that. $l('INDEX.goods_label_identifyGoodsNo') || '产品识别编号',
    field: 'identifyGoodsNo',
    minWidth: 200,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that. $l('INDEX.goods_label_orderGoodsName') || '产品名称',
    field: 'orderGoodsName',
    minWidth: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that. $l('INDEX.goods_label_orderGoodsColor') || '产品颜色',
    field: 'orderGoodsColor',
    minWidth: 150,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that. $l('INDEX.goods_label_qty') || '数量',
    field: 'qty',
    minWidth: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that. $l('INDEX.goods_label_price') || '价格',
    field: 'price',
    minWidth: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that. $l('INDEX.goods_label_salePrice') || '市场价格',
    field: 'salePrice',
    minWidth: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that. $l('INDEX.goods_label_isGroup') || '是否套装',
    field: 'v_isGroup',
    minWidth: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that. $l('INDEX.goods_label_inPackageQty') || '装箱入数',
    field: 'inPackageQty',
    minWidth: 140,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that. $l('INDEX.goods_label_packageDesc') || '外包装说明',
    field: 'packageDesc',
    minWidth: 250,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that. $l('INDEX.table_label_modified_by') || '修改人',
    field: 'modifyByName',
    minWidth: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that. $l('INDEX.table_label_modification_date') || '修改时间',
    field: 'modifyTime',
    minWidth: 170,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  }
]
